export const MOUSE_EVENTS = {
	CLICK: 'click',
	KEYPRESS: 'keypress',
	MOUSEDOWN: 'mousedown',
	MOUSEMOVE: 'mousemove',
	SCROLL: 'scroll'
};
